<div class="btn-group fn-event-filter-container" role="group" >
  <fn-button [iconAddonAfter]="uiEventFilterMap.fnBtnIconClass" id="btnGroupDrop1" (click)="showOrHideDropDown(!uiEventFilterMap.isOpenDropDown,uiEventFilterMap.isOpenDropDown)"   [btnClass]="uiEventFilterMap.fnBtnClass"  [text]="filterText"></fn-button>
  <ul class="dropdown-menu center fn-event-filter " [ngClass]="{'show': uiEventFilterMap.isOpenDropDown}" aria-labelledby="btnGroupDrop1">
    <li>
      @for (eventFilter of eventFilterArray; track eventFilter) {
        <div class="event-filter-data">
          <div class="event-filter-header">
            <h3>{{eventFilter.displayName}}</h3>
          </div>
          <fn-scrollbar [options]="{ scrollbarMinSize: 20, autoHide: false }" [sb-position]="'right'"
            style="max-height: 180px; overflow-x: auto;">
            <ul class="event-filter-list">
              @for (fnFilterOption of eventFilter.fnFilterOptionArray; track fnFilterOption) {
                <li class="event-filter-item">
                  <fn-radio [label]="fnFilterOption.displayName" [labelClass]="'filter-radio-label'" [id]="fnFilterOption.primaryKey" [name]="eventFilter.primaryKey" [(ngModel)]="eventFilter.selectedKey" (clickCallback)="enableAccept($event,eventFilter,fnFilterOption)"></fn-radio>
                </li>
              }
            </ul>
          </fn-scrollbar>
        </div>
      }
      <span class="filter-close"  (click)="showOrHideDropDown(false,true)"><i class="fn-global-times-o font-18"></i></span>
    </li>
    <li class="event-filter-footer">
      <div class="row">
        <div class="col">
          <fn-button (click)="applyOrResetFilter(false)" type="danger" btnClass="btn-round btn-xs" [ngClass]="{'disable': uiEventFilterMap.isClearDisabled}"  text ="Clear"></fn-button>
        </div>
        <div class="col text-right">
          <fn-button  (click)="applyOrResetFilter(true)"  btnClass="btn-xs btn-round btn-info"  [ngClass]="{'disable': uiEventFilterMap.isApplyDisabled}"  text = "Apply"></fn-button>
        </div>
      </div>
    </li>
  </ul>
</div>